module.exports = __webpack_public_path__ + "static/media/bags-p-img2-1.a4fd6806.jpg";